import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import moment from "moment";
import { useDebounce } from "utils";
import {
  workingPeriodStatus,
  changeArrayToWeekDay,
  gender,
} from "utils/common";
import { Input, Button } from "antd";
import styled from "@emotion/styled";
import { useCheckJobDetail, useCheckoutJob } from "utils/job-public";

export const PublicCheckoutJobScreen = () => {
  const { uuid } = useParams();
  const [param, setParam] = useState({ uuid: uuid, phone: "" });

  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isFutureDate, setIsFutureDate] = useState(false);
  const [showJobData, setShowJobData] = useState(false);
  const [jobDetail, setJobDetail] = useState<any>();

  // const [jobData, setJobData] = useState({
  //   startDate: "",
  //   startTime: "",
  //   hours: "",
  // });
  const [submitData, setSubmitData] = useState({
    uuid: uuid,
    attendanceUuid: "",
    phone: "",
  });

  const {
    mutate: getJobDetail,
    data: jobDetailData,
    isSuccess: getJobDetailSuccess,
    isError: getJobDetailError,
  } = useCheckJobDetail();

  const {
    mutate,
    isLoading,
    isError,
    isSuccess,
    data: checkoutResult,
  } = useCheckoutJob();

  const handleChange = (e: { target: { name: string; value: string } }) => {
    const { name, value } = e.target;
    setSubmitData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    setParam((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async () => {
    if (!submitData.phone) {
      return alert("please enter a phone number");
    }
    await getJobDetail({ uuid, phone: submitData.phone });
  };

  const handleComplete = async () => {
    const isConfirm = window.confirm(
      `Are you confirm ${jobDetail?.attendance === 0 ? "confirm the job" : "sign in"}？`
    );

    if (isConfirm) {
      await mutate(submitData);
    }
  };

  useEffect(() => {
    if (getJobDetailSuccess) {
      const today = moment().format("YYYY-MM-DD");
      let checkDate =
        jobDetail?.taskRecord?.startDate === today
          ? true
          : moment(jobDetail?.taskRecord?.startDate).isAfter(today);
      setIsFutureDate(checkDate);
      setJobDetail(jobDetailData);
      setSubmitData((prevState) => ({
        ...prevState,
        attendanceUuid: jobDetailData?.uuid || "",
      }));
      setShowJobData(true);
    }
  }, [getJobDetailSuccess]);

  useEffect(() => {
    if (getJobDetailError) {
      alert("invalid phone number");
    }
  }, [getJobDetailError]);

  useEffect(() => {
    if (isSuccess && checkoutResult) {
      alert(jobDetail?.attendance === 0 ? "success confirmation work" : "successfully signed");

      setIsSubmitted(true);
    }
  }, [isSuccess]);

  useEffect(() => {
    if (isError) {
      alert(jobDetail?.attendance === 0 ? "confirm that the work failed" : "check in failed");
    }
  }, [isError]);

  return (
    <Container>
      <HeaderContainer>
        <h1>UniCare360</h1>
      </HeaderContainer>

      {showJobData ? (
        <>
          <RowContainer>
            <b>job number:</b> {jobDetail?.taskRecord?.task?.taskNo}
          </RowContainer>

          <RowContainer>
            <b>date of work:</b> {jobDetail?.taskRecord?.startDate}
          </RowContainer>

          <RowContainer>
            <b>start time:</b> {jobDetail?.taskRecord?.startTime}
          </RowContainer>

          <RowContainer>
            <b>number of hours worked:</b> {jobDetail?.taskRecord?.workingHours}小時
          </RowContainer>

          <RowContainer>
            <b>work address:</b> {jobDetail?.taskRecord?.task?.district} {jobDetail?.taskRecord?.task?.address}
          </RowContainer>

          <RowContainer>
            <b>client:</b>{" "}
            {jobDetail?.taskRecord?.task?.employer?.type === 1
              ? jobDetail?.taskRecord?.task?.employer?.companyName
              : `${gender(
                  jobDetail?.taskRecord?.task?.employer?.patientGender
                )}, age: ${
                  jobDetail?.taskRecord?.task?.employer?.patientAge
                }, height: ${
                  jobDetail?.taskRecord?.task?.employer?.patientHeight
                }cm, weight: ${
                  jobDetail?.taskRecord?.task?.employer?.patientWeight
                }kg`}
          </RowContainer>

          <RowContainer>
            for enquiries please call/
            <a
              href="https://wa.me/+85298675630/?text=I would like to enquire about the details of the job"
              target="_blank"
              rel="noreferrer"
            >
              whatsApps
            </a>
            ：98675630
          </RowContainer>

          {jobDetail?.attendance === 1 && isFutureDate ? (
            <FormContainer>
              <h3 style={{ paddingTop: 30 }}>the job has been confirmed</h3>
            </FormContainer>
          ) : isSubmitted ? (
            <FormContainer>
              <h3 style={{ paddingTop: 30 }}>
                {jobDetail?.attendance === 0 ? "the job has been confirmed" : "checked in"}
              </h3>
            </FormContainer>
          ) : (
            <FormContainer>
              <Button
                type="primary"
                onClick={() => handleComplete()}
                style={{ marginTop: 20 }}
              >
                {jobDetail?.attendance === 0 ? "confirm the job" : "sign in"}
              </Button>
            </FormContainer>
          )}
        </>
      ) : (
        <FormContainer>
          <FormTitle>enter your phone number to get the job done</FormTitle>
          <Input
            placeholder="enter a phone number"
            name="phone"
            value={submitData.phone}
            onChange={handleChange}
          />
          <Button
            type="primary"
            onClick={() => handleSubmit()}
            style={{ marginTop: 20 }}
          >
            submit
          </Button>
        </FormContainer>
      )}
    </Container>
  );
};

const Container = styled.div`
  padding: 5rem 10px;
  width: 350px;
  margin: 0 auto;
`;

const HeaderContainer = styled.div`
  text-align: center;
  padding-bottom: 20px;
`;

const RowContainer = styled.div`
  padding-bottom: 10px;
`;

const FormContainer = styled.div`
  text-align: center;
`;

const FormTitle = styled.div`
  padding-top: 10px;
  padding-bottom: 5px;
  font-weight: bold;
`;
